import {
  encodeFilterState,
  type FilterState,
} from "@/lib/public-hearings/filter-state";
import { buildSlug } from "@/lib/public-hearings/slug";

export function buildFocusHref(
  filterState: FilterState,
  hearingId: number,
  hearingTitle: string,
): string {
  const sp = encodeFilterState(filterState);
  // Slug-form (e.g. "61936-land-use-amendment-in-mission-…") is
  // human-readable and SEO-friendly when shared. The leading id is
  // used by the page to look up the hearing; the title segment is a
  // canonical hint that the page redirects to if it ever drifts.
  sp.set("focus", buildSlug(hearingId, hearingTitle));
  return `/council/public-hearings?${sp.toString()}`;
}
